import React from 'react';
import { useTranslation } from 'react-i18next';
import { ProjectId } from '../../../models/Types';
import { PrioTheme } from '../../../theme/types';
import { makePrioStyles } from '../../../theme/utils';
import IncomingInvoicesSection from './accountingWidget/incomingInvoice/IncomingInvoicesSection';
import VisaCardReceiptSection from './accountingWidget/visaCardReceipt/VisaCardReceiptSection';

const useStyles = makePrioStyles((theme: PrioTheme) => ({
  root: {
    height: '100%',
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: theme.colors.application.background.default,
  },
  header: {
    padding: theme.spacing.regular,
    borderBottom: `1px solid ${theme.colors.application.border}`,
  },
  content: {
    flex: 1,
    padding: theme.spacing.regular,
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing.large,
  },
  section: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing.regular,
  },
}));

interface AccountingWidgetProps {
  projectId: ProjectId;
  className?: string;
}

const AccountingWidget: React.FC<AccountingWidgetProps> = ({
  projectId,
  className,
}) => {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <div className={`${classes.root} ${className || ''}`}>
      <div className={classes.header}>
        <h2>{t('common:widgetArea.accountingWidget.title')}</h2>
      </div>

      <div className={classes.content}>
        <div className={classes.section}>
          <IncomingInvoicesSection projectId={projectId} />
        </div>
        <div className={classes.section}>
          <VisaCardReceiptSection projectId={projectId} />
        </div>
      </div>
    </div>
  );
};

export default AccountingWidget;
